export const CROPPER_HEIGHT = 600;
export const OUTPUT_DIM = 1200;
